import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BHXH, BHYT, DKY_XE, findRequestLookups, GPLX, THUE_CN } from "services/RequestLookupService";
import { X_TOTAL_COUNT } from "utils/constants";
import { handleError } from "utils/handleError";
import { RequestLookupContext } from "./RequestLookupContext";
import { RequestLookupTraCuu } from "./RequestLookupTraCuu";

export const RequestLookupList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["request-lookup", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const requestLookupContext = useContext(RequestLookupContext);
    const {
        requestLookupBHXHs,
        setRequestLookupBHXHs,
        requestLookupBHYTs,
        setRequestLookupBHYTs,
        requestLookupDKYXEs,
        setRequestLookupDKYXEs,
        requestLookupGPLXs,
        setRequestLookupGPLXs,
        requestLookupTHUECNs,
        setRequestLookupTHUECNs,
        requestLookupDialog,
        setRequestLookupDialog,
        requestLookupData,
        setRequestLookupData,
    } = requestLookupContext;

    const [totalRecordbhxhs, setTotalRecordbhxhs] = useState(0);
    const [totalRecordbhyts, setTotalRecordbhyts] = useState(0);
    const [totalRecorddkyxes, setTotalRecorddkyxes] = useState(0);
    const [totalRecordgplxs, setTotalRecordgplxs] = useState(0);
    const [totalRecordthuecns, setTotalRecordthuecns] = useState(0);

    const [checkLoadbhxh, setCheckLoadbhxh] = useState(false);
    const [checkLoadbhyt, setCheckLoadbhyt] = useState(false);
    const [checkLoaddkyxe, setCheckLoaddkxe] = useState(false);
    const [checkLoadgplx, setCheckLoadgplx] = useState(false);
    const [checkLoadthuecn, setCheckLoadthuecn] = useState(false);

    const [submitbhxh, setSubmitbhxh] = useState(false);
    const [submitbhyt, setSubmitbhyt] = useState(false);
    const [submitdkyxe, setSubmitdkxe] = useState(false);
    const [submitgplx, setSubmitgplx] = useState(false);
    const [submitthuecn, setSubmitthuecn] = useState(false);

    const trangThais = [
        { label: "Đã tiếp nhận", value: "0" },
        { label: "Đang kiểm tra", value: "1" },
        { label: "Có lỗi khi kiểm tra thông tin", value: "2" },
        { label: "Không tìm thấy dữ liệu", value: "3" },
        { label: "Đang xử lý", value: "4" },
        { label: "Đã phê duyệt", value: "5" },
        { label: "Từ chối", value: "6" },
        { label: "Chờ tiếp nhận", value: "99" },
    ];

    const [lazyParambhxhs, setLazyParambhxhs] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            type: { value: BHXH, matchMode: "equals" },
        },
    });

    const [lazyParambhyts, setLazyParambhyts] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            type: { value: BHYT, matchMode: "equals" },
        },
    });

    const [lazyParamdkyxes, setLazyParamdkyxes] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            type: { value: DKY_XE, matchMode: "equals" },
        },
    });

    const [lazyParamgplxs, setLazyParamgplxs] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            type: { value: GPLX, matchMode: "equals" },
        },
    });

    const [lazyParamthuecns, setLazyParamthuecns] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: null, matchMode: "contains" },
            type: { value: THUE_CN, matchMode: "equals" },
        },
    });

    useEffect(() => {
        if (checkLoadbhxh) {
            loadLazyDatabhxh();
            setCheckLoadbhxh(false);
        }
    }, [lazyParambhxhs]);

    useEffect(() => {
        if (checkLoadbhyt) {
            loadLazyDatabhyt();
            setCheckLoadbhyt(false);
        }
    }, [lazyParambhyts]);

    useEffect(() => {
        if (checkLoadgplx) {
            loadLazyDatagplx();
            setCheckLoadgplx(false);
        }
    }, [lazyParamgplxs]);

    useEffect(() => {
        if (checkLoaddkyxe) {
            loadLazyDatadkyxe();
            setCheckLoaddkxe(false);
        }
    }, [lazyParamdkyxes]);

    useEffect(() => {
        if (checkLoadthuecn) {
            loadLazyDatathuecn();
            setCheckLoadthuecn(false);
        }
    }, [lazyParamthuecns]);

    const loadLazyDatabhxh = () => {
        setRequestLookupBHXHs([]);
        findRequestLookups(headers, lazyParambhxhs)
            .then((res) => {
                setTotalRecordbhxhs(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParambhxhs.rows * lazyParambhxhs.page + 1 + i;
                });
                setRequestLookupBHXHs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    const loadLazyDatabhyt = () => {
        setRequestLookupBHYTs([]);
        findRequestLookups(headers, lazyParambhyts)
            .then((res) => {
                setTotalRecordbhyts(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParambhyts.rows * lazyParambhyts.page + 1 + i;
                });
                setRequestLookupBHYTs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    const loadLazyDatagplx = () => {
        setRequestLookupGPLXs([]);
        findRequestLookups(headers, lazyParamgplxs)
            .then((res) => {
                setTotalRecordgplxs(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParamgplxs.rows * lazyParamgplxs.page + 1 + i;
                });
                setRequestLookupGPLXs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    const loadLazyDatadkyxe = () => {
        setRequestLookupDKYXEs([]);
        findRequestLookups(headers, lazyParamdkyxes)
            .then((res) => {
                setTotalRecorddkyxes(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParamdkyxes.rows * lazyParamdkyxes.page + 1 + i;
                });
                setRequestLookupDKYXEs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    const loadLazyDatathuecn = () => {
        setRequestLookupTHUECNs([]);
        findRequestLookups(headers, lazyParamthuecns)
            .then((res) => {
                setTotalRecordthuecns(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParamthuecns.rows * lazyParamthuecns.page + 1 + i;
                });
                setRequestLookupTHUECNs(dataRes);
            })
            .catch((error) => handleError(toast, t, error));
    };

    const onPagebhxh = (event) => {
        setCheckLoadbhxh(true);
        let _lazyParams = { ...lazyParambhxhs, ...event };
        setLazyParambhxhs(_lazyParams);
    };

    const onSortbhxh = (event) => {
        setCheckLoadbhxh(true);
        let _lazyParams = { ...lazyParambhxhs, ...event };
        setLazyParambhxhs(_lazyParams);
    };

    const onFilterbhxh = (event) => {
        setCheckLoadbhxh(true);
        let _lazyParams = { ...lazyParambhxhs, ...event };
        _lazyParams["first"] = 0;
        setLazyParambhxhs(_lazyParams);
    };

    const onPagebhyt = (event) => {
        setCheckLoadbhyt(true);
        let _lazyParams = { ...lazyParambhyts, ...event };
        setLazyParambhyts(_lazyParams);
    };

    const onSortbhyt = (event) => {
        setCheckLoadbhyt(true);
        let _lazyParams = { ...lazyParambhyts, ...event };
        setLazyParambhyts(_lazyParams);
    };

    const onFilterbhyt = (event) => {
        setCheckLoadbhyt(true);
        let _lazyParams = { ...lazyParambhyts, ...event };
        _lazyParams["first"] = 0;
        setLazyParambhyts(_lazyParams);
    };

    const onPagedkyxe = (event) => {
        setCheckLoaddkxe(true);
        let _lazyParams = { ...lazyParamdkyxes, ...event };
        setLazyParamdkyxes(_lazyParams);
    };

    const onSortdkyxe = (event) => {
        setCheckLoaddkxe(true);
        let _lazyParams = { ...lazyParamdkyxes, ...event };
        setLazyParamdkyxes(_lazyParams);
    };

    const onFilterdkyxe = (event) => {
        setCheckLoaddkxe(true);
        let _lazyParams = { ...lazyParamdkyxes, ...event };
        _lazyParams["first"] = 0;
        setLazyParamdkyxes(_lazyParams);
    };

    const onPagegplx = (event) => {
        setCheckLoadgplx(true);
        let _lazyParams = { ...lazyParamgplxs, ...event };
        setLazyParamgplxs(_lazyParams);
    };

    const onSortgplx = (event) => {
        setCheckLoadgplx(true);
        let _lazyParams = { ...lazyParamgplxs, ...event };
        setLazyParamgplxs(_lazyParams);
    };

    const onFiltergplx = (event) => {
        setCheckLoadgplx(true);
        let _lazyParams = { ...lazyParamgplxs, ...event };
        _lazyParams["first"] = 0;
        setLazyParamgplxs(_lazyParams);
    };

    const onPagethuecn = (event) => {
        setCheckLoadthuecn(true);
        let _lazyParams = { ...lazyParamthuecns, ...event };
        setLazyParamthuecns(_lazyParams);
    };

    const onSortthuecn = (event) => {
        setCheckLoadthuecn(true);
        let _lazyParams = { ...lazyParamthuecns, ...event };
        setLazyParamthuecns(_lazyParams);
    };

    const onFilterthuecn = (event) => {
        setCheckLoadthuecn(true);
        let _lazyParams = { ...lazyParamthuecns, ...event };
        _lazyParams["first"] = 0;
        setLazyParamthuecns(_lazyParams);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOptionbhxh = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("request-lookup.idNumber")} <span className="text-danger">*</span>
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={lazyParambhxhs.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadbhxh(false);
                                setLazyParambhxhs({
                                    ...lazyParambhxhs,
                                    filters: {
                                        ...lazyParambhxhs.filters,
                                        idNumber: {
                                            ...lazyParambhxhs.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>
            <div className="col-12 md:col-8 text-right customr-form ">
                <div className="grid">
                    <div className="col-12">
                        <label
                            className="col-12 text-center"
                            style={{
                                width: "85px",
                                justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (!lazyParambhxhs.filters.idNumber.value) {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("request-lookup.idNumberrequest"), life: 3000 });
                                    return;
                                }
                                setSubmitbhxh(true);
                                if (lazyParambhxhs.filters.idNumber.value) {
                                    setCheckLoadbhxh(true);
                                    setLazyParambhxhs({
                                        ...lazyParambhxhs,
                                        first: 0,
                                        page: 0,
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptionbhyt = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("request-lookup.idNumber")} <span className="text-danger">*</span>
                    </label>
                    <div className="col" style={{ display: "grid" }}>
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={lazyParambhyts.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadbhyt(false);
                                setLazyParambhyts({
                                    ...lazyParambhyts,
                                    filters: {
                                        ...lazyParambhyts.filters,
                                        idNumber: {
                                            ...lazyParambhyts.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-8 text-right">
                <div className="grid">
                    <div className="col-12">
                        <label
                            className="col-12 text-center"
                            style={{
                                width: "85px",
                                justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (!lazyParambhyts.filters.idNumber.value) {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("request-lookup.idNumberrequest"), life: 3000 });

                                    return;
                                }
                                setSubmitbhyt(true);
                                if (lazyParambhyts.filters.idNumber.value) {
                                    setCheckLoadbhyt(true);
                                    setLazyParambhyts({
                                        ...lazyParambhyts,
                                        first: 0,
                                        page: 0,
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptiondkyxe = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4 ">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("request-lookup.idNumber")} <span className="text-danger">*</span>
                    </label>
                    <div className="col" style={{ display: "grid" }}>
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={lazyParamdkyxes.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoaddkxe(false);
                                setLazyParamdkyxes({
                                    ...lazyParamdkyxes,
                                    filters: {
                                        ...lazyParamdkyxes.filters,
                                        idNumber: {
                                            ...lazyParamdkyxes.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-8 text-right ">
                <div className="grid">
                    <div className="col-12">
                        <label
                            className="col-12 text-center"
                            style={{
                                width: "85px",
                                justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (!lazyParamdkyxes.filters.idNumber.value) {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("request-lookup.idNumberrequest"), life: 3000 });
                                    return;
                                }
                                setSubmitdkxe(true);
                                if (lazyParamdkyxes.filters.idNumber.value) {
                                    setCheckLoaddkxe(true);
                                    setLazyParamdkyxes({
                                        ...lazyParamdkyxes,
                                        first: 0,
                                        page: 0,
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptiongplx = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("request-lookup.idNumber")} <span className="text-danger">*</span>
                    </label>
                    <div className="col" style={{ display: "grid" }}>
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={lazyParamgplxs.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadgplx(false);
                                setLazyParamgplxs({
                                    ...lazyParamgplxs,
                                    filters: {
                                        ...lazyParamgplxs.filters,
                                        idNumber: {
                                            ...lazyParamgplxs.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                        {submitgplx && !lazyParamgplxs.filters.idNumber.value && <small className="text-danger">{ }</small>}
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-8 text-right">
                <div className="grid">
                    <div className="col-12">
                        <label
                            className="col-12 text-center"
                            style={{
                                width: "85px",
                                justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (!lazyParamgplxs.filters.idNumber.value) {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("request-lookup.idNumberrequest"), life: 3000 });
                                    return;
                                }
                                setSubmitgplx(true);
                                if (lazyParamgplxs.filters.idNumber.value) {
                                    setCheckLoadgplx(true);
                                    setLazyParamgplxs({
                                        ...lazyParamgplxs,
                                        first: 0,
                                        page: 0,
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const searchOptionthuecn = (
        <div className="grid">
            {/* số ĐDCN */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center custom-form"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("request-lookup.idNumber")} <span className="text-danger">*</span>
                    </label>
                    <div className="col" style={{ display: "grid" }}>
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            value={lazyParamthuecns.filters.idNumber.value}
                            onChange={(e) => {
                                setCheckLoadthuecn(false);
                                setLazyParamthuecns({
                                    ...lazyParamthuecns,
                                    filters: {
                                        ...lazyParamthuecns.filters,
                                        idNumber: {
                                            ...lazyParamthuecns.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-8 text-right">
                <div className="grid">
                    <div className="col-12">
                        <label
                            className="col-12 text-center"
                            style={{
                                width: "85px",
                                justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (!lazyParamthuecns.filters.idNumber.value) {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("request-lookup.idNumberrequest"), life: 3000 });
                                    return;
                                }
                                setSubmitthuecn(true);
                                if (lazyParamthuecns.filters.idNumber.value) {
                                    setCheckLoadthuecn(true);
                                    setLazyParamthuecns({
                                        ...lazyParamthuecns,
                                        first: 0,
                                        page: 0,
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button mr-2"
                    // tooltip={t("view", { ns: "common" })}
                    onClick={() => {
                        const data = JSON.parse(rowData.ketQuaTraCuu);
                        if (data?.data) {
                            setRequestLookupData(data?.data);
                        } else {
                            setRequestLookupData(null);
                        }
                        setRequestLookupDialog(true);
                    }}
                />
            </div>
        );
    };

    const trangThaiBodyTemplate = (rowData) => {
        return <div className="flex align-items-center justify-content-center actions">{trangThais.find((e) => e.value == rowData.trangThai)?.label}</div>;
    };

    const formatDateNgaySinhTemplate = (rowData) => {
        if (rowData.ngaySinh) {
            return <div className="flex align-items-left justify-content-left actions">{rowData.ngaySinh?.substr(0, 10)?.replaceAll("-", "/")}</div>;
        }
        return null;
    };

    const ngayGuiTemplate = (rowData) => {
        if (rowData.ngayGui) {
            return <div className="flex align-items-left justify-content-left actions">{rowData.ngayGui?.replaceAll("-", "/")}</div>;
        }
        return null;
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("approval-result.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <Toast ref={toast} />
                    <div className="grid">
                        <div className="col-12">
                            <TabView>
                                <TabPanel header={t("request-lookup.bhxh")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptionbhxh}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("request-lookup.listbhxh")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={requestLookupBHXHs}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    rows={lazyParambhxhs.rows}
                                                    first={lazyParambhxhs.first}
                                                    totalRecords={totalRecordbhxhs}
                                                    onPage={onPagebhxh}
                                                    onSort={onSortbhxh}
                                                    sortField={lazyParambhxhs.sortField}
                                                    sortOrder={lazyParambhxhs.sortOrder}
                                                    onFilter={onFilterbhxh}
                                                    filters={lazyParambhxhs.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="soCccdNgDkyTk" header={t("request-lookup.soCccdNgDkyTk")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="maSoBhxh" header={t("request-lookup.maSoBhxh")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="hoTen" header={t("request-lookup.hoTen")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngaySinh" header={t("request-lookup.ngaySinh")} body={formatDateNgaySinhTemplate} style={{ minWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="trangThai" header={t("request-lookup.trangThai")} body={trangThaiBodyTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngayGui" header={t("request-lookup.ngayGui")} body={ngayGuiTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="lanGui" header={t("request-lookup.lanGui")} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column body={actionBodyTemplate} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header={t("request-lookup.bhyt")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptionbhyt}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("request-lookup.listbhyt")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={requestLookupBHYTs}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    rows={lazyParambhyts.rows}
                                                    first={lazyParambhyts.first}
                                                    totalRecords={totalRecordbhyts}
                                                    onPage={onPagebhyt}
                                                    onSort={onSortbhyt}
                                                    sortField={lazyParambhyts.sortField}
                                                    sortOrder={lazyParambhyts.sortOrder}
                                                    onFilter={onFilterbhyt}
                                                    filters={lazyParambhyts.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="soCccdNgDkyTk" header={t("request-lookup.soCccdNgDkyTk")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="maSoTheBhyt" header={t("request-lookup.maSoTheBhyt")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="hoTen" header={t("request-lookup.hoTen")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngaySinh" header={t("request-lookup.ngaySinh")} body={formatDateNgaySinhTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="trangThai" header={t("request-lookup.trangThai")} body={trangThaiBodyTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngayGui" header={t("request-lookup.ngayGui")} body={ngayGuiTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="lanGui" header={t("request-lookup.lanGui")} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column body={actionBodyTemplate} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header={t("request-lookup.dkyxe")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptiondkyxe}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("request-lookup.listdkyxe")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={requestLookupDKYXEs}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    rows={lazyParamdkyxes.rows}
                                                    first={lazyParamdkyxes.first}
                                                    totalRecords={totalRecorddkyxes}
                                                    onPage={onPagedkyxe}
                                                    onSort={onSortdkyxe}
                                                    sortField={lazyParamdkyxes.sortField}
                                                    sortOrder={lazyParamdkyxes.sortOrder}
                                                    onFilter={onFilterdkyxe}
                                                    filters={lazyParamdkyxes.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="soCccdNgDkyTk" header={t("request-lookup.soCccdNgDkyTk")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="soCnDkyXe" header={t("request-lookup.soCnDkyXe")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="hoTen" header={t("request-lookup.hoTen")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngaySinh" header={t("request-lookup.ngaySinh")} body={formatDateNgaySinhTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="loaiPhuongTien" header={t("request-lookup.loaiPhuongTien")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="bienSoXe" header={t("request-lookup.bienSoXe")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="trangThai" header={t("request-lookup.trangThai")} body={trangThaiBodyTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngayGui" header={t("request-lookup.ngayGui")} body={ngayGuiTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="lanGui" header={t("request-lookup.lanGui")} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column body={actionBodyTemplate} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header={t("request-lookup.gplx")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptiongplx}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("request-lookup.listgplx")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={requestLookupGPLXs}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    rows={lazyParamgplxs.rows}
                                                    first={lazyParamgplxs.first}
                                                    totalRecords={totalRecordgplxs}
                                                    onPage={onPagegplx}
                                                    onSort={onSortgplx}
                                                    sortField={lazyParamgplxs.sortField}
                                                    sortOrder={lazyParamgplxs.sortOrder}
                                                    onFilter={onFiltergplx}
                                                    filters={lazyParamgplxs.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="soCccdNgDkyTk" header={t("request-lookup.soCccdNgDkyTk")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="soGplx" header={t("request-lookup.soGplx")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="tenChuXe" header={t("request-lookup.tenChuXe")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngaySinh" header={t("request-lookup.ngaySinh")} body={formatDateNgaySinhTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="hang" header={t("request-lookup.hang")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="trangThai" header={t("request-lookup.trangThai")} body={trangThaiBodyTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngayGui" header={t("request-lookup.ngayGui")} body={ngayGuiTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="lanGui" header={t("request-lookup.lanGui")} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column body={actionBodyTemplate} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header={t("request-lookup.thuecn")}>
                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("search", { ns: "common" })}>{searchOptionthuecn}</BlockDetail>
                                        </div>
                                    </div>

                                    <div className="grid">
                                        <div className="col-12">
                                            <BlockDetail title={t("request-lookup.listthuecn")}>
                                                <DataTable
                                                    ref={dt}
                                                    value={requestLookupTHUECNs}
                                                    dataKey="stt"
                                                    className="datatable-responsive p-datatable-sm"
                                                    showGridlines
                                                    lazy
                                                    paginator
                                                    rows={lazyParamthuecns.rows}
                                                    first={lazyParamthuecns.first}
                                                    totalRecords={totalRecordthuecns}
                                                    onPage={onPagethuecn}
                                                    onSort={onSortthuecn}
                                                    sortField={lazyParamgplxs.sortField}
                                                    sortOrder={lazyParamgplxs.sortOrder}
                                                    onFilter={onFilterthuecn}
                                                    filters={lazyParamgplxs.filters}
                                                    paginatorClassName="justify-content-start"
                                                    paginatorTemplate={paginatorTemplate}
                                                    emptyMessage="Không có dữ liệu"
                                                    scrollable
                                                >
                                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                                    <Column field="soCccdNgDkyTk" header={t("request-lookup.soCccdNgDkyTk")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="maSoThue" header={t("request-lookup.maSoThue")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="hoTen" header={t("request-lookup.hoTen")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngaySinh" header={t("request-lookup.ngaySinh")} body={formatDateNgaySinhTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="trangThai" header={t("request-lookup.trangThai")} body={trangThaiBodyTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="ngayGui" header={t("request-lookup.ngayGui")} body={ngayGuiTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column field="lanGui" header={t("request-lookup.lanGui")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                    <Column body={actionBodyTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                                </DataTable>
                                            </BlockDetail>
                                        </div>
                                    </div>
                                </TabPanel>
                            </TabView>
                            <RequestLookupTraCuu />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
